/**
 * Canonical SPA routes for navigation after auth and “return to app” actions.
 * Today’s Focus is the default home after login/register/MFA (see product UX).
 */
export const DEFAULT_APP_HOME = '/today'
